module.exports = __webpack_public_path__ + "media/src/images/top_covers/April_01-73654ee76f09b519c3ce5df08fe548fa.png";